/* Keep the original saved list; hydrate current prices and sizes from Shopify. */
(() => {
  'use strict';
  const KEY = 'tn_wishlist_v1';
  const strings = JSON.parse(document.querySelector('#CommerceStrings')?.textContent || '{}');
  const copy = JSON.parse(document.querySelector('#SavedStrings')?.textContent || '{}');
  const root = (document.body.dataset.root || '/').replace(/\/?$/, '/');
  const page = document.querySelector('[data-wishlist-page]');
  const grid = page?.querySelector('[data-wishlist-grid]');
  const cache = new Map();
  const valid = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  function read() {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(saved) ? saved.filter((p,i,a) => valid(p?.handle) && a.findIndex(v=>v?.handle===p.handle)===i).slice(-200) : [];
    } catch { return []; }
  }
  let items = read(), generation = 0, request, removed, temporary = false;
  let filter = 'all', sort = 'recent';
  const has = handle => items.some(p=>p.handle===handle);
  const say = text => { const status = document.querySelector('#ShopStatus'); if (status) status.textContent = text || ''; };
  function sync(scope = document) {
    scope.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
      const active = has(button.dataset.wishlistToggle);
      const label = active ? button.dataset.labelRemove : button.dataset.labelAdd;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', label + ' — ' + button.dataset.productTitle);
      const span = button.querySelector('[data-wishlist-label]');
      if (span && span.textContent !== label) span.textContent = label;
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(span => {
      if (span.textContent !== String(items.length)) span.textContent = String(items.length);
      span.hidden = !items.length;
    });
    if (!page) return;
    page.dataset.savedFilled = String(!!items.length);
    page.querySelector('[data-saved-total]').textContent = String(items.length).padStart(2, '0');
    page.querySelector('[data-saved-count-label]').textContent = items.length === 1 ? copy.one : copy.many;
    page.querySelector('[data-saved-device]').textContent = temporary ? strings.wishlist_temporary : copy.device;
    page.querySelector('[data-wishlist-empty]').hidden = !!items.length;
    page.querySelector('[data-saved-toolbar]').hidden = !items.length;
    let visible = 0;
    page.querySelectorAll('[data-saved-suggestion]').forEach(card => {
      card.hidden = has(card.dataset.savedSuggestion) || visible >= 4;
      if (!card.hidden) visible++;
    });
    page.querySelector('[data-saved-discover]').hidden = !visible;
  }
  const fallbackFan = page?.querySelector('[data-saved-fan]')?.cloneNode(true);
  function updateFan() {
    if (!page) return;
    const fan = page.querySelector('[data-saved-fan]');
    const images = [...items].reverse().map(p=>cache.get(p.handle)?.querySelector('.card-image')).filter(Boolean).slice(0,3);
    const signature = images.map(img=>img.getAttribute('src')).join('|');
    if (fan.dataset.signature === signature) return;
    fan.dataset.signature = signature;
    if (!images.length) { fan.replaceChildren(...[...fallbackFan.children].map(n=>n.cloneNode(true))); return; }
    fan.replaceChildren(...images.map(img => {
      const frame = document.createElement('div'); frame.className = 'saved-print';
      const photo = img.cloneNode(true); photo.className = 'saved-print-image'; photo.alt = ''; photo.loading = 'eager'; photo.sizes = '240px';
      const caption = document.createElement('span'); caption.textContent = 'THUNDERNOISE®';
      frame.append(photo,caption); return frame;
    }));
  }
  function arrange() {
    if (!page) return;
    const ordered = [...items].reverse().map(p=>grid.querySelector(`[data-wishlist-item="${p.handle}"]`)).filter(Boolean);
    const loading = ordered.some(n=>n.hasAttribute('data-wishlist-loading'));
    page.querySelectorAll('[data-saved-filter], [data-saved-sort]').forEach(el=>el.disabled=loading);
    if (sort !== 'recent') ordered.sort((a,b) => {
      const aPrice = Number(a.dataset.savedPrice), bPrice = Number(b.dataset.savedPrice);
      if (!Number.isFinite(aPrice)) return Number.isFinite(bPrice) ? 1 : 0;
      if (!Number.isFinite(bPrice)) return -1;
      return sort === 'low' ? aPrice - bPrice : bPrice - aPrice;
    });
    let shown = 0;
    ordered.forEach(card => {
      grid.append(card);
      card.hidden = filter !== 'all' && card.dataset[filter === 'sale' ? 'savedSale' : 'savedAvailable'] !== 'true';
      if (!card.hidden) shown++;
    });
    ['all','available','sale'].forEach(type=>{
      page.querySelector(`[data-filter-count="${type}"]`).textContent = String(type === 'all' ? items.length : ordered.filter(n=>n.dataset[type === 'sale' ? 'savedSale' : 'savedAvailable']==='true').length);
    });
    page.querySelector('[data-saved-filter-empty]').hidden = !items.length || !!shown || loading;
    updateFan();
  }
  function errorCard(handle, slot) {
    slot.removeAttribute('data-wishlist-loading'); slot.className = 'wishlist-unavailable';
    const p = document.createElement('p'); p.textContent = strings.wishlist_unavailable;
    const link = document.createElement('a'); link.href = root+'products/'+handle; link.textContent = handle.replaceAll('-',' '); link.className = 'text-link';
    const retry = document.createElement('button'); retry.type = 'button'; retry.dataset.savedRetry = handle; retry.className = 'text-link'; retry.textContent = copy.retry;
    const button = document.createElement('button'); button.type = 'button'; button.dataset.wishlistToggle = handle;
    button.dataset.labelAdd = strings.wishlist_add; button.dataset.labelRemove = strings.wishlist_remove; button.dataset.productTitle = link.textContent;
    button.textContent = strings.wishlist_remove; button.className = 'text-link'; slot.replaceChildren(p,link,retry,button);
  }
  async function renderPage() {
    if (!page) return;
    const run = ++generation;
    request?.abort(); request = new AbortController();
    const signal = request.signal;
    const handles = [...items].reverse().map(p=>p.handle);
    grid.querySelectorAll('[data-wishlist-item]').forEach(card=>{if (!has(card.dataset.wishlistItem)) card.remove();});
    const pending = [];
    handles.forEach(handle=>{
      let slot = grid.querySelector(`[data-wishlist-item="${handle}"]`);
      if (cache.has(handle)) { if (!slot || slot !== cache.get(handle)) { slot?.remove(); grid.append(cache.get(handle)); } return; }
      if (!slot) { slot = document.createElement('div'); slot.dataset.wishlistItem = handle; grid.append(slot); }
      slot.className = ''; slot.replaceChildren(); slot.dataset.wishlistLoading = ''; pending.push({handle,slot});
    });
    const status = page.querySelector('[data-wishlist-status]');
    status.textContent = pending.length ? strings.loading : '';
    grid.setAttribute('aria-busy', String(!!pending.length));
    arrange();
    let cursor = 0;
    await Promise.all(Array.from({length:Math.min(4,pending.length)},async()=>{
      while (cursor < pending.length && run === generation) {
        const {handle,slot} = pending[cursor++];
        try {
          const response = await fetch(root+'products/'+handle+'?section_id=atelier-wishlist-card',{signal});
          if (!response.ok) throw new Error('unavailable');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const card = doc.querySelector('[data-wishlist-item]');
          if (!card || !card.querySelector('.product-card')) throw new Error('unavailable');
          if (run === generation && has(handle)) { cache.set(handle,card); slot.replaceWith(card); sync(card); }
        } catch (error) {
          if (signal.aborted || run !== generation) return;
          errorCard(handle,slot);
        }
      }
    }));
    if (run === generation) { status.textContent = ''; grid.setAttribute('aria-busy','false'); sync(); arrange(); }
  }
  function commit(next, message, action, handle) {
    try { localStorage.setItem(KEY,JSON.stringify(next)); temporary = false; } catch { temporary = true; }
    items = next; sync(); renderPage(); say(temporary ? strings.wishlist_temporary : message);
    window.dispatchEvent(new CustomEvent('tn:wishlist:changed',{detail:{items,action,handle}}));
  }
  document.addEventListener('click', event=>{
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button || !valid(button.dataset.wishlistToggle)) return;
    event.preventDefault();
    const handle = button.dataset.wishlistToggle, saved = has(handle);
    if (!saved && items.length >= 200) { say(copy.limit || strings.wishlist_limit); return; }
    if (saved && page) {
      removed = {item:items.find(p=>p.handle===handle),index:items.findIndex(p=>p.handle===handle)};
      const undo = page.querySelector('[data-saved-undo]'); undo.hidden = false;
      page.querySelector('[data-saved-undo-message]').textContent = strings.wishlist_removed;
      if (button.closest('[data-wishlist-grid]')) page.querySelector('[data-saved-restore]').focus({preventScroll:true});
    }
    const next = saved ? items.filter(p=>p.handle!==handle) : [...items,{handle,addedAt:Date.now()}];
    if (!saved && button.closest('[data-saved-suggestion]')) page?.querySelector('[data-saved-sort]')?.focus({preventScroll:true});
    commit(next,saved ? strings.wishlist_removed : strings.wishlist_saved,saved ? 'remove' : 'add',handle);
  });
  page?.addEventListener('click',event=>{
    const filterButton = event.target.closest('[data-saved-filter]');
    if (filterButton) {
      filter = filterButton.dataset.savedFilter;
      page.querySelectorAll('[data-saved-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===filterButton)));
      arrange();
    }
    if (event.target.closest('[data-saved-retry]')) renderPage();
    if (event.target.closest('[data-saved-restore]') && removed) {
      const {item,index} = removed;
      if (!has(item.handle)) {
        if (items.length >= 200) { say(copy.limit); return; }
        const next = [...items]; next.splice(Math.min(index,next.length),0,item);
        commit(next,strings.wishlist_saved,'add',item.handle);
      }
      removed = null; page.querySelector('[data-saved-undo]').hidden = true;
      page.querySelector('[data-saved-sort]').focus({preventScroll:true});
    }
  });
  page?.querySelector('[data-saved-sort]')?.addEventListener('change',event=>{sort=event.target.value;arrange();});
  window.addEventListener('storage',event=>{if(event.key===KEY || event.key===null){items=read();sync();renderPage();}});
  new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{
    if(node.nodeType===1) { if(node.matches('[data-wishlist-toggle]')) sync(node.parentElement); else if(node.querySelector('[data-wishlist-toggle]')) sync(node); }
  }))).observe(document.body,{childList:true,subtree:true});
  sync(); renderPage();
})();
